import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { map, Observable, of } from 'rxjs';

import { API_ENDPOINTS } from '@typings/api-endpoints.type';
import { ApiQueryParams } from '@utils/api-query-params.type';
import { buildQueryParams } from '@utils/query';
import { MembershipServices } from '../../domain';
import { Plan } from '@modules/super-admin/company/domain';

@Injectable()
export class MembershipServicesImpl implements MembershipServices {
  constructor(private client: HttpClient) {}

  getAllMembership(query: ApiQueryParams): Observable<Plan[]> {
    const params = buildQueryParams(query);
    // const params = new HttpParams().set('archived', false);
    return this.client
      .get<any>(environment.apiDomain + API_ENDPOINTS.PLANS.GET_ALL(), {
        params,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAllCards(userId: string): Observable<any> {
    return this.client
      .get<any>(environment.apiDomain + API_ENDPOINTS.WALLET.GET_ALL(userId))
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  deleteCard(userId: string, paymentMethodId: string): Observable<any> {
    return this.client
      .delete<any>(
        environment.apiDomain +
          API_ENDPOINTS.WALLET.DELETE_CARD(userId, paymentMethodId)
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  subscribeToPlan(subscriptionData: {
    _planId: string;
    _userId: string;
  }): Observable<any> {
    return this.client
      .post<any>(
        environment.apiDomain + API_ENDPOINTS.SUBSCRIPTIONS.SUBSCRIBE(),
        subscriptionData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updatePlanSubscription(
    companyId: string,
    data: {
      _planId: string;
      _userId: string;
      paymentMethodId: string;
    }
  ): Observable<any> {
    return this.client
      .patch<any>(
        environment.apiDomain +
          API_ENDPOINTS.SUBSCRIPTIONS.UPDATE_MEMBERSHIP(companyId),
        data
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addCard(userId: string, token: any): Observable<any> {
    return this.client
      .post<any>(
        environment.apiDomain + API_ENDPOINTS.WALLET.ADD_CARD(userId),
        token
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  cancelMembership(_user: string, _company: string): Observable<any> {
    return this.client
      .delete<any>(
        environment.apiDomain +
          API_ENDPOINTS.COMPANY.CANCEL_MEMBERSHIP(_company)
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
